import { useQuery } from '@tanstack/react-query';

import getImpersonationUsers from '../api/getImpersonationUsers';

const useImpersonationUsers = (q: string) => {
  return useQuery({
    queryKey: ['impersonation-users-autocomplete', q],
    queryFn: () => getImpersonationUsers(q),
    enabled: q.length >= 2
  });
};

export default useImpersonationUsers;
